"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require("immutable");

var I = _interopRequireWildcard(_immutable);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Cell = require("./Cell");

var _Cell2 = _interopRequireDefault(_Cell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Row = function Row(props) {
  var children = props.children,
      data = props.data,
      highlight = props.highlight;

  var className = (0, _classnames2.default)("erg-components-Row", {
    "highlighted": highlight
  });
  return _react2.default.createElement(
    "tr",
    { className: className },
    children.map(function (item, idx) {
      return _react2.default.createElement(_Cell2.default, {
        column: item,
        data: data,
        key: "item-" + idx });
    })
  );
};

Row.displayName = "Row";

Row.propTypes = {
  children: _propTypes2.default.array.isRequired,
  data: _propTypes2.default.instanceOf(I.Record).isRequired,
  highlight: _propTypes2.default.bool
};

exports.default = Row;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/table/Row.js
 ** module id = 799
 ** module chunks = 0
 **/